import React, {Fragment} from 'react'
import { Heading } from '@myxplor/ui'
import './heading-rocket.css'

/*global require */
const Rocket = require('./rocket.svg')

const HeadingRocket = ({children}) => (
  <Fragment>
    <Heading sup="Xplor">{children}</Heading>
    <img className='rocketLogo' src={Rocket} alt='xplor-logo' />
  </Fragment>
)

export default HeadingRocket


// WEBPACK FOOTER //
// ./src/heading-rocket/index.jsx